/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { CriterionBase } from "@/models/api/filters/criterions/CriterionBase";
import { getFilter } from "@/requests/general";
import { FILTER_NAMES } from "@/static/filterNames";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import i18n from "@/plugins/i18n";

export interface FiltersStateInterface {
  unProfiledFilters: Record<string, Array<CriterionBase>>;
  filterValues: Record<string, Array<CriterionItemRequest>>;
}

export const FiltersState: FiltersStateInterface = {
  unProfiledFilters: {},
  filterValues: {},
};

const FiltersModule = defineModule({
  state: FiltersState as FiltersStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setFilter(state, props: { filterName: string; filter: Array<CriterionBase> }) {
      state.unProfiledFilters[props.filterName + i18n.locale] = props.filter;
    },
    setDeleteFilter(state, filterName: string) {
      delete state.unProfiledFilters[filterName + i18n.locale];
    },
    setPreservedFilterValue(state, props: { filterName: string; values: Array<CriterionItemRequest> }) {
      state.filterValues[props.filterName] = props.values;
    },
  },
  actions: {
    async getFilter(context, filterName: FILTER_NAMES): Promise<Array<CriterionBase>> {
      const { commit, state } = _moduleActionContext(context);
      if (typeof state.unProfiledFilters[filterName + i18n.locale] === "undefined") {
        const filter = await getFilter(filterName);
        commit.setFilter({ filterName: filterName, filter: filter.criterions });
      }
      return JSON.parse(JSON.stringify(state.unProfiledFilters[filterName + i18n.locale]));
    },
    async refreshFilter(context, filterName: FILTER_NAMES): Promise<void> {
      const { commit } = _moduleActionContext(context);
      const filter = await getFilter(filterName);
      commit.setFilter({ filterName: filterName, filter: filter.criterions });
    },
    async removeFilter(context, filterName: FILTER_NAMES): Promise<void> {
      const { commit } = _moduleActionContext(context);
      commit.setDeleteFilter(filterName);
    },
  },
});

export default FiltersModule;

/* eslint-disable  @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, FiltersModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, FiltersModule);
